import React from 'react';

const Spain = (props) => (
  <svg width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_3127_46008)">
      <rect width="28" height="20" rx="3" fill="#F93939" />
      <path
        d="M25.3333 0H2.66667C1.19391 0 0 1.19391 0 2.66667V17.3333C0 18.8061 1.19391 20 2.66667 20H25.3333C26.8061 20 28 18.8061 28 17.3333V2.66667C28 1.19391 26.8061 0 25.3333 0Z"
        fill="#F93939"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M0 5.3335H28V14.6668H0V5.3335Z" fill="#FFDA2C" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0002 8.29621V11.6562C12.0002 12.5895 11.1042 13.3362 10.0002 13.3362H7.3335C6.23216 13.3335 5.3335 12.5829 5.3335 11.6535V8.29354C5.3335 7.53088 5.93083 6.89354 6.75216 6.68688C7.00016 5.99354 7.76283 6.61488 8.66683 6.61488C9.57616 6.61488 10.3335 5.99754 10.5815 6.68821C11.4002 6.90021 12.0002 7.53888 12.0002 8.29621Z"
        fill="#D4AF2C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 9.3335H13.3333V13.3335H12V9.3335ZM4 9.3335H5.33333V13.3335H4V9.3335Z"
        fill="#CBCBCB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 12H13.3333V13.3333H12V12ZM4 12H5.33333V13.3333H4V12Z"
        fill="#1A47B8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 8H13.3333V9.33333H12V8ZM4 8H5.33333V9.33333H4V8Z"
        fill="#D4AF2C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.6665 8H7.99984V10H6.6665V8ZM9.33317 10.6667H10.6665V12.6667H9.33317V10.6667Z"
        fill="#AF010D"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M6.6665 10.6665H7.99984V12.6665H6.6665V10.6665Z" fill="#FFDA2C" />
      <path fillRule="evenodd" clipRule="evenodd" d="M9.3335 8H10.6668V10H9.3335V8Z" fill="#AE6A3E" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99984 7.99984L6.6665 6.6665H10.6665L9.33317 7.99984H7.99984Z"
        fill="#AF010D"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M8 5.3335H9.33333V6.66683H8V5.3335Z" fill="#D4AF2C" />
    </g>
    <rect x="0.25" y="0.25" width="27.5" height="19.5" rx="2.75" stroke="#AEAEAE" strokeWidth="0.5" />
    <defs>
      <clipPath id="clip0_3127_46008">
        <rect width="28" height="20" rx="3" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Spain;
